<template>
  <div>
    <h4 class="info-text">
      Avertissements
    </h4>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-8">
        <p>
          Les informations affichées par Peamoni sont issues d'algorithmes et 
          ne sont en aucun cas des recommandations ou des conseils.
          Les algorithmes sont potentiellement défaillants et ne doivent pas être considérés 
          comme une incitation à l'achat ou à la vente de valeurs.
          <br><br>
          Ce site ne pourrait être en aucun cas responsable directement ou 
          indirectement de l'utilisation qui est faite du contenu du site ou 
          tout élément constituant ce site, mais également de toute perte 
          subie ou de toute décision prise sur la base d'éléments de ce site. 
          <br><br>
          Il est recommandé à toute personne non avertie de prendre conseil 
          auprès de professionnels avant tout investissement.
        </p>
        </div>
      </div>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-8">

        <base-checkbox 
          v-model="model.termsAccepted"
          class="text-center">
          J'accepte les conditions et j'ai pris connaissances des avertissements.
        </base-checkbox>
      </div>
    </div>
  </div>
</template>
<script>

import { BaseCheckbox } from 'src/components';

export default {
  data() {
    return {
      model: {
        termsAccepted: false
      },
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      if( this.model.termsAccepted )
      return this.$validator.validateAll().then(res => {
        this.$emit('on-validated', res, this.model);
        return res;
      });
    }
  }
};
</script>
<style></style>
